import resultsList from "./resultsList";

export default `
  ${resultsList}
`;
